module.exports = __webpack_public_path__ + "img/353a3e8b-b658-4528-a477-887350ee9142.b3ce793c.png";